<script>

export default {
  name: "TextareaFieldComponent",
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
    },
    validationError: {
      type: Array,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    errMessage() {
      return this.validationError?.length ? this.validationError[0] : null
    }
  }
}
</script>

<template>
  <div :class="['mb-3', {'has_error': errMessage}]">
    <label v-if="label" :class="{'required' : required}">{{ label }}</label>
      <textarea
          class="form-control"
          :value="modelValue"
          @input="$emit('update:modelValue', $event.target.value)"
          :placeholder="placeholder"
          rows="5"
      ></textarea>
      <small class="has_error" v-if="validationError">{{ errMessage }}</small>
  </div>
</template>

<style scoped>

</style>